import PropTypes from 'prop-types';
import React from 'react';
import { Col, Panel, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import { add } from '../../../reducers/workOrder/employeeTimesheets/employeeTimesheets.actions';
import { timesheets } from '../../../reducers/workOrder/employeeTimesheets/employeeTimesheets.reducer';
import { dirty } from '../../../reducers/workOrder/workOrders.reducer';
import SpinnerButton from '../../SpinnerButton/SpinnerButton';
import ConnectedEmployeeTimesheetForm from './EmployeeTimesheetForm/EmployeeTimesheetForm';
import './EmployeeTimesheets.css';

// eslint-disable-next-line object-curly-newline
export const EmployeeTimesheets = ({ employeeTimesheets, addEmployeeTimesheet, workOrderId, saveWorkOrder, workOrderDirty, disabled }) => {
  const usedEmployees = employeeTimesheets.map(a => a.employee_id);
  return (
    <Panel header="Employees" >
      {employeeTimesheets.map(timesheet => (
        <Row key={timesheet.id} >
          <Col xs={12} >
            <ConnectedEmployeeTimesheetForm employee={timesheet} usedEmployees={usedEmployees} disabled={disabled} />
          </Col>
        </Row>
      ))}
      <Row>
        { !disabled &&
        <Col xs={6} sm={3} >
          <SpinnerButton onClick={() => addEmployeeTimesheet(workOrderId)} >Add Employee</SpinnerButton>
        </Col>
        }
        <Col xs={6} sm={2} >
          <SpinnerButton
            onClick={saveWorkOrder}
            bsStyle="primary"
            dirty={workOrderDirty}
            disabled={disabled}
          >
            Save
          </SpinnerButton>
        </Col>
      </Row>
    </Panel>
  );
};

EmployeeTimesheets.propTypes = {
  employeeTimesheets: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  workOrderDirty: PropTypes.bool.isRequired,
  workOrderId: PropTypes.string.isRequired,
  saveWorkOrder: PropTypes.func.isRequired,
  addEmployeeTimesheet: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
};

export const mapStateToProps = (state, ownProps) => ({
  employeeTimesheets: timesheets(ownProps.workOrderId, state),
  workOrderDirty: dirty(state, ownProps.workOrderId),
});

export const mapDispatchToProps = dispatch => ({
  addEmployeeTimesheet: id => dispatch(add(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(EmployeeTimesheets);



// WEBPACK FOOTER //
// ./src/components/WorkOrder/Employees/EmployeeTimesheets.jsx